import { render } from "./EdoSectionIcon.vue?vue&type=template&id=274699b4&scoped=true"
import script from "./EdoSectionIcon.vue?vue&type=script&lang=js"
export * from "./EdoSectionIcon.vue?vue&type=script&lang=js"

import "./EdoSectionIcon.vue?vue&type=style&index=0&id=274699b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274699b4"]])

export default __exports__